import React, {Component} from "react";
import MaterialTable from 'material-table'
import {ProgressBar} from 'react-bootstrap';
import { Bar } from 'react-chartjs-2'
import BarChartIcon from '@material-ui/icons/BarChart';
import Button from '@material-ui/core/Button'
import { Scrollbar } from "react-scrollbars-custom";
import {get_apm_data_from_mongo} from "../UserFunctions"
import Loader from "../../utilityComponents/MiniLoader";

class apm_file_list_view extends Component {
    constructor(props){
        super(props);

        this.state = {
            scenario_data:[],
            performance_data:[],
            showBar:false,
            loader: true,
          }
        this.simulation_data = this.simulation_data.bind(this);
        this.graph_data=this.graph_data.bind(this);
    }
    componentDidMount(){
        this.simulation_data()
        this.interval = setInterval(() => this.setState({ time: Date.now() }), 10);
    }
    componentWillUnmount() {
        clearInterval(this.interval);
      }

    simulation_data() {
      get_apm_data_from_mongo('/apm_filelist').then(
            (response) => {
              this.setState({
                scenario_data: response.data['scenario_status'],
                performance_data: response.data['system_performance'],
                loader: false
            })
        })
    }
    graph_data(){
        return(
            this.setState(prevState => ({
                showBar: !prevState.showBar
              }))
        )}

    render () {
     const { showBar} = this.state;
     const scenario_data_copy=this.state.scenario_data
     const performance_data_copy=this.state.performance_data

     const timestamp = performance_data_copy.map(a=>a.timestamp)
     const gpu_mem_used_percent = performance_data_copy.map(a=>a.gpu_memory_used)
     const cpu_utilization = performance_data_copy.map(a => a.cpu_utilization)
     const available_memory = performance_data_copy.map(a => a.gpu_available_memory)

     const scenario_columns=[
        {title:'Topology_Id',field:'topology_id'},
//        {title:'Scheduler Id',field:'scheduler_id'},
        {title:'Scenario Group Id',field:'scenario_group_id'},
        {title:'Instance Id',field:'instance_id'},
        {title:'Scenario Count',field:'scenario_count'},
        {title:'Total Scenarios',field:'total_scenarios'},
        {title:'Retry Count',field:'retry_count'},
        {title:'Status',field:'status'},
        {title:'Scenario UUID',field:'scenario_uuid'},
        {title:'IP Address',field:'ip_address'},
        {title:'Total Exec Time (seconds)',field:'total_exec_time'},
    ]

    const performance_columns=[
        {title:'Topology_Id',field:'topology_id'},
//        {title:'Schedular Id',field:'scheduler_id'},
        {title:'Scenario Group Id',field:'scenario_group_id'},
        {title:'Instance Id',field:'instance_id'},
        {title:'Time Stamp',field:'timestamp'},
        {title:'CPU Utilization',field:'cpu_utilization',render: rowData =><ProgressBar animated variant="info" now={rowData.cpu_utilization} label={`${rowData.cpu_utilization} %  completed `} />},
        {title:'CPU Memory Usage',field:'cpu_memory_usage',render: rowData =><ProgressBar animated variant="info" now={rowData.cpu_memory_usage} label={`${rowData.cpu_memory_usage} %  completed `} />},
        {title:'CPU Available Memory',field:'cpu_memory_usage',render: rowData =><ProgressBar animated variant="info" now={rowData.cpu_available_memory} label={`${rowData.cpu_available_memory} %  completed `} />},
        {title:'GPU Utilization',field:'gpu_utilization',render: rowData =><ProgressBar animated variant="info" now={rowData.gpu_utilization} label={`${rowData.gpu_utilization} %  completed `} />},
        {title:'GPU Memory Used',field:'gpu_mem_used_percent',render: rowData =><ProgressBar animated variant="info" now={rowData.gpu_memory_used} label={`${rowData.gpu_memory_used} %  completed `} />},
        {title:'GPU Available Memory',field:'gpu_available_memory',render: rowData =><ProgressBar animated variant="info" now={rowData.gpu_available_memory} label={`${rowData.gpu_available_memory} %  completed `} />}
    ]
    return (
        <div className="card-body">
            {this.state.loader ?(
                <div>
                    <Loader/>
                </div>
                ):(
                <div>
                    <h3 style={{textAlign:"center"}}>Scenario Status Data</h3>
                    <MaterialTable title=""
                    data={scenario_data_copy}
                    columns={scenario_columns}
                    options={{
                        filtering : true,
                        paging:true,
                        headerStyle: {
                            fontSize: 20,
                            textAlign: 'center',
                            color: 'white',
                            backgroundColor: '#9932CC',
                        }
                    }}
                    />
                    <h3 style={{textAlign:"center"}}>System Performance Data</h3>
                    <MaterialTable title=""
                    data={performance_data_copy}
                    columns={performance_columns}
                    options={{
                        filtering : true,
                        paging:true,
                        headerStyle: {
                            fontSize: 20,
                            textAlign: 'center',
                            color: 'white',
                            backgroundColor: '#9932CC',
                        }
                    }}
                    />
                    {showBar && <Scrollbar style={{ width: 10000, height: 400 }}>
                    <h4 style={{ textAlign: "Left" }}>GPU Memory used percent</h4>
                    <Bar
                        data={{
                            labels: timestamp,
                            datasets: [
                                {
                                    label: '# of gpu_mem_used_percent',
                                    data: gpu_mem_used_percent,
                                    borderWidth: 2,
                                    backgroundColor: 'rgba(235, 80, 54, 0.3)',
                                }
                            ]
                        }}
                        options ={ {
                            scales: {
                                yAxes: [{
                                    scaleLabel: {
                                        display: true,
                                        labelString: 'GPU Memory Utilization % ',
                                        fontSize:17,
                                        fontColor:'black'
                                    }
                                }],
                                xAxes: [{
                                    scaleLabel: {
                                        display: true,
                                        labelString: 'Timestamp',
                                        fontSize:17,
                                        fontColor:'black'
                                    }
                                }],
                            }
                        }}
                        height={350}
                        width={10000}
                    />
                    </Scrollbar>}
                    {showBar && <Scrollbar style={{ width: 10000, height: 400 }}>
                    <h4 style={{ textAlign: "Left" }}>CPU Utilization</h4>
                    <Bar
                        data={{
                            labels: timestamp,
                            datasets: [
                                {
                                    label: '# of cpu_utilization',
                                    data: cpu_utilization,
                                    borderWidth: 2,
                                    backgroundColor: 'rgba(54, 162, 235, 0.3)',
                                }
                            ]
                        }}
                        options ={ {
                            scales: {
                                yAxes: [{
                                    scaleLabel: {
                                        display: true,
                                        labelString: 'CPU Utilization %',
                                        fontSize:17,
                                        fontColor:'black'
                                    }
                                }],
                                xAxes: [{
                                    scaleLabel: {
                                        display: true,
                                        labelString: 'Timestamp',
                                        fontSize:17,
                                        fontColor:'black'
                                    }
                                }],
                            }
                        }}
                        height={350}
                        width={10000}
                    />
                    </Scrollbar>}
                    {showBar && <Scrollbar style={{ width: 10000, height: 400 }}>
                    <h4 style={{ textAlign: "Left" }}>Available Memory</h4>
                    <Bar
                        data={{
                            labels: timestamp,
                            datasets: [
                                {
                                    label: '# of available memory',
                                    data: available_memory,
                                    borderWidth: 2,
                                    backgroundColor: 'rgba(20, 235, 20, 0.3)',
                                }
                            ]
                        }}
                        options ={ {
                            scales: {
                                yAxes: [{
                                    scaleLabel: {
                                        display: true,
                                        labelString: 'Available Memory %',
                                        fontSize:17,
                                        fontColor:'black'
                                    }
                                }],
                                xAxes: [{
                                    scaleLabel: {
                                        display: true,
                                        labelString: 'Timestamp',
                                        fontSize:17,
                                        fontColor:'black'
                                    }
                                }],
                            }
                        }}
                        height={350}
                        width={10000}
                    />
                    </Scrollbar>}
                    <div style={{textAlign: "center",}}>
                        <Button variant="contained" style={{marginLeft:"auto",marginRight:"auto"}} color="primary" onClick={this.graph_data} >View/HideCharts <BarChartIcon/></Button>
                    </div>
                </div>
            )}
        </div>
    )
}
}
export default apm_file_list_view



